'use strict';

const util = require('../components/util');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('.primary-images').append(
        '<div class="add-to-wishlist-messages "></div>'
        );

        if (window.innerWidth > 543) {
            $('.wishlist-item, .sticky-wishlist').append(
                '<div class="add-to-wishlist-messages "></div>'
            );
        }
    }
    if ($('.wishlist-button').attr('data-loggedUser') === 'true') {
        $('.add-to-wishlist-messages')
            .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');
    } else {
        $('.add-to-wishlist-messages')
            .append('<div class="add-to-wishlist-alert text-center ' + status + '"><a href="' + data.wishlistUrl + '">' + data.notLoggedMsg + '</a></div>');
    }

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 5000);
}

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.wishlist-button.js-add-to-wish-list', function (e) {
            e.preventDefault();
            var url = $(this).data('href');
            var button = $(this);
            var pid = $(this).closest('.product-detail').find('.product-id').html();
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessage(data);

                    button.find('i').removeClass('icon-heart-pdp').addClass('icon-heart-pdp-hover');
                    button.removeClass('js-add-to-wish-list').addClass('js-remove-from-wish-list');
                    if ($('.sticky-wishlist').length > 0) {
                        $('.sticky-wishlist').find('i').removeClass('icon-heart-pdp').addClass('icon-heart-pdp-hover');
                        $('.sticky-wishlist').removeClass('js-add-to-wish-list').addClass('js-remove-from-wish-list');
                    }
                },
                error: function (err) {
                    displayMessage(err);
                }
            });
        });
    },

    removeProductFromWishlist: function () {
        $('body').on('click', '.wishlist-button.js-remove-from-wish-list', function (e) {
            e.preventDefault();
            var url = $(this).data('removeurl');
            var button = $(this);
            var pid = button.attr('data-productid');

            var newUrl = util.getPathFromUrl(url);

            $.spinner().start();
            $.ajax({
                url: `${newUrl}?pid=${pid}`,
                type: 'get',
                dataType: 'json',
                data: {},
                success: function (data) {
                    displayMessage(data);

                    button.find('i').removeClass('icon-heart-pdp-hover').addClass('icon-heart-pdp');
                    button.removeClass('js-remove-from-wish-list').addClass('js-add-to-wish-list');
                    if ($('.sticky-wishlist').length > 0) {
                        $('.sticky-wishlist').find('i').removeClass('icon-heart-pdp-hover').addClass('icon-heart-pdp');
                        $('.sticky-wishlist').removeClass('js-remove-from-wish-list').addClass('js-add-to-wish-list');
                    }
                },
                error: function (err) {
                    displayMessage(err);
                }
            });
        });
    }
};
